import api from "@/services/api";
import { ENDPOINTS_CONTRACTS, ENDPOINTS_MILESTONES } from "@/services/endpoints";

export const listContracts = () => api.get(ENDPOINTS_CONTRACTS.list).then((r) => r.data);

export const createContract = (payload) =>
  api.post(ENDPOINTS_CONTRACTS.create, payload).then((r) => r.data);

export const getContract = (id) => api.get(ENDPOINTS_CONTRACTS.detail(id)).then((r) => r.data);

export const addMilestone = (id, payload) =>
  api.post(ENDPOINTS_CONTRACTS.addMilestone(id), payload).then((r) => r.data);

export const acceptContract = (id) =>
  api.post(ENDPOINTS_CONTRACTS.accept(id)).then((r) => r.data);

export const declineContract = (id) =>
  api.post(ENDPOINTS_CONTRACTS.decline(id)).then((r) => r.data);

export const fundMilestone = (id, payload) =>
  api.post(ENDPOINTS_MILESTONES.fund(id), payload).then((r) => r.data);

export const submitWork = (id, payload) =>
  api.post(ENDPOINTS_MILESTONES.submit(id), payload).then((r) => r.data);

export const approveMilestone = (id) =>
  api.post(ENDPOINTS_MILESTONES.approve(id)).then((r) => r.data);

export const requestChanges = (id, payload) =>
  api.post(ENDPOINTS_MILESTONES.requestChanges(id), payload).then((r) => r.data);

export const releaseMilestone = (id) =>
  api.post(ENDPOINTS_MILESTONES.release(id)).then((r) => r.data);

export const cancelMilestone = (id, payload) =>
  api.post(ENDPOINTS_MILESTONES.cancel(id), payload).then((r) => r.data);

export const confirmFundMilestone = (id) =>
  api.post(ENDPOINTS_MILESTONES.fundConfirm(id)).then((r) => r.data);

export const remindFunding = (id) =>
  api.post(ENDPOINTS_MILESTONES.remindFunding(id)).then((r) => r.data);

export const proposeRevision = (id, payload) =>
  api.post(ENDPOINTS_MILESTONES.revise(id), payload).then((r) => r.data);

export const approveRevision = (id) =>
  api.post(ENDPOINTS_MILESTONES.reviseApprove(id)).then((r) => r.data);

export const declineRevision = (id) =>
  api.post(ENDPOINTS_MILESTONES.reviseDecline(id)).then((r) => r.data);

export const withdrawRevision = (id) =>
  api.post(ENDPOINTS_MILESTONES.reviseWithdraw(id)).then((r) => r.data);

export const authorizeRevise = (id) =>
  api.post(ENDPOINTS_MILESTONES.reviseAuthorize(id)).then((r) => r.data);

export const confirmRevise = (id) =>
  api.post(ENDPOINTS_MILESTONES.reviseConfirm(id)).then((r) => r.data);

export const confirmClaimMilestone = (id) =>
  api.post(ENDPOINTS_MILESTONES.claimConfirm(id)).then((r) => r.data);

export const disputeMilestone = (id, payload) =>
  api.post(ENDPOINTS_MILESTONES.dispute(id), payload).then((r) => r.data);

export const invoiceFromMilestone = (id) =>
  api.post(ENDPOINTS_MILESTONES.invoice(id)).then((r) => r.data);
